<template>
  <section class="container mt-4 sitemap-page" aria-labelledby="sitemap-heading">
    <h1 id="sitemap-heading" class="page-title">Sitemap</h1>
    <p class="sitemap-intro">All pages on Grow With Stocks, grouped by topic. Use this list to navigate the site as an alternative to the main menu.</p>

    <nav aria-label="Sitemap">
      <h2 class="mt-4">About &amp; Services</h2>
      <ul>
        <li><router-link to="/">Home</router-link></li>
        <li><router-link to="/about">About Grow With Stocks</router-link></li>
        <li><router-link to="/pricing">Pricing &amp; Plans</router-link></li>
        <li><router-link to="/services">Services</router-link></li>
        <li><router-link to="/faq">Frequently Asked Questions</router-link></li>
        <li><router-link to="/contact">Contact Us</router-link></li>
      </ul>

      <h2 class="mt-4">Investor Information</h2>
      <ul>
        <li><router-link to="/investor-charter">Investor Charter</router-link></li>
        <li><router-link to="/investor-complaints">Investor Complaints</router-link></li>
        <li><router-link to="/grievance">Grievance Redressal</router-link></li>
        <li><router-link to="/valid-upi">Valid UPI Handles</router-link></li>
      </ul>

      <h2 class="mt-4">Disclosures &amp; Policies</h2>
      <ul>
        <li><router-link to="/mandatory-disclosure">Mandatory Disclosure</router-link></li>
        <li><router-link to="/compliance-audit">Compliance Audit</router-link></li>
        <li><router-link to="/conflicts-of-interest">Conflict of Interest Policy</router-link></li>
        <li><router-link to="/anti-money-laundering-policy">Anti-Money Laundering Policy</router-link></li>
        <li><router-link to="/terms-and-conditions">Terms and Conditions</router-link></li>
        <li><router-link to="/disclaimer">Disclaimer</router-link></li>
      </ul>
    </nav>
  </section>
</template>

<script>
  export default {
    name: "Sitemap",
    mounted() {
      document.title = "Sitemap | Grow With Stocks";
    }
  };
</script>

<style lang="scss" scoped>
  .sitemap-page {
    min-height: 70vh;
    padding-bottom: 48px;
  }
  .page-title {
    text-align: center;
    color: #1a1a1a;
    font-weight: 800;
    margin-bottom: 12px;
  }
  .sitemap-intro {
    text-align: center;
    color: #595959;
    font-size: 16px;
    line-height: 26px;
    max-width: 720px;
    margin: 0 auto 32px;
  }
  h2 {
    font-size: 22px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 12px;
  }
  ul {
    list-style: disc inside;
    padding-left: 0;
    margin-bottom: 16px;
  }
  li {
    margin: 6px 0;
    font-size: 16px;
    line-height: 26px;
  }
  a {
    color: #1a7055;
    text-decoration: underline;
    font-weight: 500;
  }
  a:hover,
  a:focus {
    color: #0d3d2e;
  }
  a:focus-visible {
    outline: 3px solid #ffbf47;
    outline-offset: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Sitemap.vue